import React from 'react';
import { Divider } from '@material-ui/core';
import { ThemeProvider } from '@knockrentals/knock-shared-web-v2';
import { PageHeader } from '../../../knock-design-system';
import { ActivateChannelsSection } from './ActivateChannelsSection';
import { ActionButtonsToolbar } from './ActionButtonsToolbar';
import { SyndicationDataTable } from './SyndicationDataTable';
import { SyndicationDrawer } from './SyndicationDrawer/SyndicationDrawer';
import { useSyndication } from './use-syndication';
import { DRAWER_MODES } from './constants';
import './_SyndicationPage.scss';

export const TITLE = 'Syndication';
export const DESCRIPTION =
  'Manage and activate Internet Listing Service (ILS) channels for your properties.';

const SyndicationPage = () => {
  const {
    drawerMode,
    errorMessage,
    filteredChannels,
    getSyndication,
    handleDrawerMode,
    isActivateChannelsVisible,
    isLoading,
    propertiesSyndication,
    setSyndicationTableSelectedProperties,
    syndicationTableSelectedProperties,
    totalPropertyCount,
    updatePropertySyndication,
  } = useSyndication();

  return (
    <ThemeProvider>
      <section className="syndication-page">
        <PageHeader title={TITLE} description={DESCRIPTION} />
        <Divider />
        <ActionButtonsToolbar
          handleDrawerMode={handleDrawerMode}
          isClonePropertiesDisabled={false}
          isManageChannelsButtonDisabled={false}
        />

        <SyndicationDrawer
          drawerMode={drawerMode}
          handleDrawerMode={handleDrawerMode}
        />

        {isActivateChannelsVisible ? (
          <ActivateChannelsSection
            onClick={handleDrawerMode(DRAWER_MODES.MANAGE)}
          />
        ) : (
          <SyndicationDataTable
            errorMessage={errorMessage}
            filteredChannels={filteredChannels}
            getSyndication={getSyndication}
            isLoading={isLoading}
            propertiesSyndication={propertiesSyndication}
            setSelectedProperties={setSyndicationTableSelectedProperties}
            selectedProperties={syndicationTableSelectedProperties}
            totalPropertyCount={totalPropertyCount}
            updatePropertySyndication={updatePropertySyndication}
          />
        )}
      </section>
    </ThemeProvider>
  );
};

export default SyndicationPage;
